import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_CarouselImg = _resolveComponent("CarouselImg")!
  const _component_CategorieImg = _resolveComponent("CategorieImg")!
  const _component_DistributorMap = _resolveComponent("DistributorMap")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home",
    style: _normalizeStyle({ height: _ctx.totalHeightInPx + 'px' })
  }, [
    _createVNode(_component_Navbar),
    _createVNode(_component_CarouselImg, { height: _ctx.carouselImgHeight }, null, 8, ["height"]),
    _createVNode(_component_CategorieImg, { height: _ctx.categorieImgHeight }, null, 8, ["height"]),
    _createVNode(_component_DistributorMap, {
      id: "distributor-map",
      height: _ctx.distributorMapHeight
    }, null, 8, ["height"]),
    _createVNode(_component_Footer, { height: _ctx.footerHeight }, null, 8, ["height"])
  ], 4))
}